import { ColDef, ISimpleFilterModelType, SetFilterModelValue } from 'ag-grid-enterprise';
import { ReportColumnKeys, SupportedColumnFilterType } from '../report-column';

/* ** Filters ** */
export type TextColumnFilter = {
    filterType: 'text';
    filter: string | null;
    type: ISimpleFilterModelType;
};

export type NumberColumnFilter = {
    filterType: 'number';
    filter: number | null;
    type: ISimpleFilterModelType;
};

export type DateColumnFilter = {
    filterType: 'date';
    /** Format is YYYY-MM-DDThh:mm:ss */
    dateFrom: string | null;

    /** Format is YYYY-MM-DDThh:mm:ss */
    dateTo?: string | null;

    type: ISimpleFilterModelType;
};

export type SetColumnFilter = {
    filterType: 'set';
    values: SetFilterModelValue;
};

export type ColumnFilter = TextColumnFilter | NumberColumnFilter | DateColumnFilter | SetColumnFilter;

export type ColumnFilters = Partial<Record<ReportColumnKeys, ColumnFilter>>;

export const FILTER_TYPE_TO_AG_FILTER_MAP: Record<SupportedColumnFilterType, ColDef['filter']> = {
    text: 'agTextColumnFilter',
    number: 'agNumberColumnFilter',
    date: 'agDateColumnFilter',
    set: 'agSetColumnFilter'
};

/* ToDo: Is this needed??? */
export const AG_FILTER_TO_FILTER_TYPE_MAP: Record<ColDef['filter'], SupportedColumnFilterType> = {
    agTextColumnFilter: 'text',
    agNumberColumnFilter: 'number',
    agDateColumnFilter: 'date',
    agSetColumnFilter: 'set'
};
